import { useNavigate, useParams } from '@tanstack/react-router';
import { getDripEmailReport } from '../../../../../common/api/dripEmails';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Container, Header } from '@cloudscape-design/components';
import { ViewLayout } from '../../../../../components/ViewLayout';
import { LoadingOrError } from '../../../../../components/Loading';

export default function DripEmailReportPage() {
  const { uuid } = useParams({ from: '/drip/emails/$uuid/report' });
  const navigate = useNavigate();

  const query = useQuery({
    queryKey: ['drip', 'emails', uuid, 'report'],
    queryFn: () => getDripEmailReport(uuid ?? ''),
  });

  useEffect(() => {
    if (query.data) {
      navigate({ to: `/${(query.data as { uuid: string }).uuid}` });
    }
  }, [query.data]);

  return (
    <ViewLayout
      breadcrumbs={[{ text: 'Reports', href: '/' }]}
      header={<Header variant="h1">Loading...</Header>}
      contentType="dashboard"
      navigationHide
    >
      <Container>
        <LoadingOrError
          loading={query.isLoading}
          error={query.error}
          retry={() => query.refetch()}
        />
      </Container>
    </ViewLayout>
  );
}
